export default "__VITE_PUBLIC_ASSET__2c666652__"